
import UserVo from "@/vo/UserVo";
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    item: Object,
  },
})
export default class ServeItem extends Vue {
  user = UserVo.getInstance();
  get shareholderState() {
    if (!this.user.id) {
      this.user.req_data();
    }
    return this.user.shareholderState;
  }
}

